import React from 'react';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner } from 'reactstrap';
import { Typography } from '@mui/material';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import qs from 'qs';
import Select from '../../Template/Input/Select';
import MaskedInput from '../../Template/Input/MaskedInput';
import AddFiles from '../../Template/Files/AddFiles';
import FormInputTooltip from '../../Template/Tooltip/FormInputTooltip';
import currencyFormatter from '../../../utils/currencyFormatter';
import { selectValues } from '../../../utils/fc';
import oikosApi from '../../../services/oikos';
import powerAppsApi from '../../../services/powerapps';
import { notifyError, notifySuccess } from '../../../utils/notify';
import {
  buildResumoOrcamentoPorAno,
  isVigenciaDatasInvalidas,
} from '../../Template/Doc/orcResumoOrcamentarioUtils';
import ConsoleButton from '../../TestPhaseComponent/ConsoleButton';
import {
  abrirVagaInhireParaPedidoCompra,
  fetchOrcItemContratoFornId,
  insertCandidatoFromCompraCotacao,
  resolveVagaIdForEquipePedidoCompra,
  savePedidoCompraOuVagaDocuments,
  updateVaga,
  usePedidoCompraEquipeActions,
} from './usePedidoCompraEquipeActions';
import {
  CONTR_FORN_BENEFICIOS_OPTIONS,
  fetchDocumentosObrigatoriosTpDocumentoOptions,
  parseContrFornBeneficios,
  parseMultiSelectIds,
} from '../ModalFormContrForn/contrFornExtendedFields';
import { COMPRA_STATUS_ABERTO } from '../../Template/Doc/compraCotacaoTableUtils';

const CONTRATO_DATE_ERROR_MESSAGE = 'Data selecionada incoerente com as datas do contrato do projeto';

const VAGA_CONDICOES_TRABALHO_OPTIONS = [
  { value: 'Presencial', label: 'Presencial' },
  { value: 'Híbrido', label: 'Híbrido' },
  { value: 'Remoto', label: 'Remoto' },
  { value: 'Campo', label: 'Campo' },
  { value: 'Cliente', label: 'Cliente' },
];

const VAGA_FORNECEDOR_EPIS_OPTIONS = [
  { value: 'Prestadora', label: 'Prestadora' },
  { value: 'Tomadora', label: 'Tomadora' },
  { value: 'Cliente', label: 'Cliente' },
  { value: 'Conforme projeto', label: 'Conforme projeto' },
];

export const EQUIPE_CATEG_GR_ID = 2;
const EMPTY_OBJECT = {};
const EMPTY_ARRAY = [];

const isDateBefore = (dateA, dateB) => {
  if (!dateA || !dateB) return false;
  return moment(dateA, 'YYYY-MM-DD', true).isBefore(moment(dateB, 'YYYY-MM-DD', true), 'day');
};

const isDateAfter = (dateA, dateB) => {
  if (!dateA || !dateB) return false;
  return moment(dateA, 'YYYY-MM-DD', true).isAfter(moment(dateB, 'YYYY-MM-DD', true), 'day');
};

const PEDIDO_COMPRA_STATUS_APROVADO = 5;

const buildPedidoCompraFormDataForEdit = (pedidoCompra = {}, vaga = {}, orcItem = {}) => ({
  ...pedidoCompra,
  ...vaga,
  pedidoCompra_id: pedidoCompra.pedidoCompra_id,
  pedidoCompraStatus_id: pedidoCompra.pedidoCompraStatus_id,
  pedidoCompra_desc: pedidoCompra.pedidoCompra_desc || vaga.vaga_descricao || '',
  pedidoCompra_vlrLimite: pedidoCompra.pedidoCompra_vlrLimite ?? vaga.vaga_salarioMaximo ?? 0,
  pedidoCompra_dtVigIni: pedidoCompra.pedidoCompra_dtVigIni || vaga.vaga_dtVigIni || null,
  pedidoCompra_dtVigFim: pedidoCompra.pedidoCompra_dtVigFim || vaga.vaga_dtVigFim || null,
  pedidoCompra_dtLimiteEntrega: pedidoCompra.pedidoCompra_dtLimiteEntrega || vaga.vaga_dtLimiteEntrega || null,
  pf_id: Number(orcItem.pf_id) || Number(pedidoCompra.pf_id) || null,
  orcItem_id: pedidoCompra.orcItem_id || vaga.orcItem_id,
  centroDeCustoRubr_id: orcItem.centroDeCustoRubr_id || orcItem.nivel2_id || pedidoCompra.centroDeCustoRubr_id || null,
  projAtuacao_id: orcItem.projAtuacao_id || pedidoCompra.projAtuacao_id || null,
  categGr_id: orcItem.categGr_id || pedidoCompra.categGr_id,
  vaga_id: vaga.vaga_id,
  vaga_descricao: vaga.vaga_descricao || pedidoCompra.pedidoCompra_desc || '',
  vagaEstado: vaga.vaga_localidadeEstado != null ? Number(vaga.vaga_localidadeEstado) || vaga.vaga_localidadeEstado : null,
  vagaCidade: vaga.vaga_localidadeCidade != null ? Number(vaga.vaga_localidadeCidade) || vaga.vaga_localidadeCidade : null,
  vaga_localidadeEstado: vaga.vaga_localidadeEstado != null ? Number(vaga.vaga_localidadeEstado) || vaga.vaga_localidadeEstado : null,
  vaga_localidadeCidade: vaga.vaga_localidadeCidade != null ? Number(vaga.vaga_localidadeCidade) || vaga.vaga_localidadeCidade : null,
  vagaContrato: vaga.vaga_tipoContrato,
  vaga_tipoContrato: vaga.vaga_tipoContrato,
  vagaCargo: vaga.vaga_cargo,
  vaga_cargo: vaga.vaga_cargo,
  vagaFormacao: vaga.vaga_formacao,
  vaga_formacao: vaga.vaga_formacao,
  vagaNome: vaga.vaga_nome,
  vaga_nome: vaga.vaga_nome,
  vagaEscopo: vaga.vaga_escopo,
  vaga_escopo: vaga.vaga_escopo,
  vagaRequisitos: vaga.vaga_requisitos,
  vaga_requisitos: vaga.vaga_requisitos,
  vagaBeneficios: parseContrFornBeneficios(vaga.vaga_beneficios),
  vaga_beneficios: parseContrFornBeneficios(vaga.vaga_beneficios),
  vagaCondicoesTrabalho: vaga.vaga_condicoesTrabalho,
  vaga_condicoesTrabalho: vaga.vaga_condicoesTrabalho,
  vagaFornecedorEpis: vaga.vaga_fornecedorEpis,
  vaga_fornecedorEpis: vaga.vaga_fornecedorEpis,
  vagaDocumentosObrigatorios: parseMultiSelectIds(vaga.vaga_documentosObrigatorios),
  vaga_documentosObrigatorios: parseMultiSelectIds(vaga.vaga_documentosObrigatorios),
  vaga_inhireId: vaga.vaga_inhireId || null,
  orcItem_original: orcItem.orcItem_original || null,
  task_comentario: pedidoCompra.task_comentario || null,
});

const getArquivoExtension = (path = '') => {
  const normalizedPath = String(path || '').split('?')[0];
  const extension = normalizedPath.split('.').pop();
  return extension && extension !== normalizedPath ? extension : '';
};

const formatPedidoCompraDocumentoFile = (documento) => {
  const arquivoPath = documento?.arquivo_caminho || documento?.documento_desc || 'Documento salvo';
  const extension = getArquivoExtension(arquivoPath);
  const name = String(arquivoPath).replace(/\.[^/.]+$/, '');
  return {
    data: { path: arquivoPath, size: 0, type: '' },
    props: {
      id: `pedido-compra-doc-${documento?.documentoVinc_id || documento?.documento_id || documento?.arquivo_id || arquivoPath}`,
      preview: '',
      modified: '',
      icon: {},
      extension,
      name,
      documentType: documento?.tpDocumento_id
        ? { tpDocumento_id: documento.tpDocumento_id, tpDocumento_desc: documento.tpDocumento_desc }
        : null,
      description: documento?.documento_desc || null,
      documento_id: documento?.documento_id,
      documentoVinc_id: documento?.documentoVinc_id,
      arquivo_id: documento?.arquivo_id,
      arquivo_caminho: documento?.arquivo_caminho,
      isPersisted: true,
    },
  };
};

export const fetchPedidoCompraDocuments = async (pedidoCompraId, table = 'pedidoCompra') => {
  const pedidoCompraIdNormalizado = Number(pedidoCompraId) || 0;
  if (!pedidoCompraIdNormalizado) return [];

  const response = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'documentoVinc',
    data: {
      documentoVinc_tabRef: table,
      documentoVinc_tabId: pedidoCompraIdNormalizado,
      documentoVinc_ativo: 1,
    },
    fields: {
      documentoVinc_id: 'documentoVinc_id',
      documento_id: 'documento_id',
      '(SELECT documento_desc FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_desc',
      '(SELECT documento_ativo FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'documento_ativo',
      '(SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1)': 'tpDocumento_id',
      '(SELECT tpDocumento_desc FROM tpDocumento WHERE tpDocumento.tpDocumento_id = (SELECT tpDocumento_id FROM documento WHERE documento.documento_id = documentoVinc.documento_id LIMIT 1) LIMIT 1)': 'tpDocumento_desc',
      '(SELECT arquivo_id FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_id',
      '(SELECT arquivo_caminho FROM arquivo WHERE arquivo.arquivo_tabRef = "documento" AND arquivo.arquivo_tabId = documentoVinc.documento_id AND arquivo.arquivo_ativo = 1 ORDER BY arquivo_id DESC LIMIT 1)': 'arquivo_caminho',
    },
  })}`);

  return (response?.data || [])
    .filter((doc) => Number(doc?.documento_ativo) === 1)
    .map(formatPedidoCompraDocumentoFile);
};

export const fetchOrcItemsForCentroDeCusto = async (centroDeCustoRubrId, { categGrId } = {}) => {
  const centroId = Number(centroDeCustoRubrId) || 0;
  if (!centroId) return [];

  const response = await oikosApi.get(`/?${qs.stringify({
    action: 'get',
    table: 'viewRubr_OrcItem',
    fields: {
      orcItem_id: 'value',
      item_orcamentario: 'label',
      nivel2_id: 'cc_id',
      nivel2: 'cc_nome',
      "(SELECT categGr_id FROM categ WHERE categ.categ_id = viewRubr_OrcItem.categ_id LIMIT 1)": 'categGr_id',
      "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)": 'pf_id',
      "(SELECT contratoForn_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)": 'contratoForn_id',
      "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)": 'projAtuacao_id',
    },
    data: {
      orcItem_ativo: 1,
      nivel2_id: centroId,
    },
    order: 'label',
  })}`);

  const items = Array.isArray(response?.data) ? response.data : [];
  const categGrFilter = Number(categGrId) || 0;
  if (!categGrFilter) return items;
  return items.filter((item) => Number(item.categGr_id) === categGrFilter);
};

const buildCotacaoFormDataFromCompraCotacao = (compraCotacao = {}, pedidoCompra = {}) => ({
  ...pedidoCompra,
  pedidoCompra_id: Number(pedidoCompra.pedidoCompra_id || compraCotacao.pedidoCompra_id) || null,
  pedidoCompra_desc: compraCotacao.compraCotacao_desc || '',
  compraCotacao_desc: compraCotacao.compraCotacao_desc || '',
  pedidoCompra_vlrLimite: compraCotacao.compraCotacao_vlr ?? 0,
  compraCotacao_vlr: compraCotacao.compraCotacao_vlr ?? 0,
  compraCotacao_id: compraCotacao.compraCotacao_id || null,
  compraCotacao_link: compraCotacao.compraCotacao_link || '',
  compraCotacao_nomeInteressado: compraCotacao.compraCotacao_nomeInteressado || '',
});

function usePedidoCompraModalController({
  isOpen,
  initialPedidoCompraData = {},
  initialFilesPedidoCompra = [],
  editPedidoCompraRow = null,
  editCompraCotacaoRow = null,
  readOnly = false,
  hideCentroDeCusto = false,
  showEquipePedidoCompraFields = false,
  allowPedidoSemOrcItem = false,
  modoCotacao = false,
  cotacaoParaPedidoExistente = false,
  compraCotacaoParaPedidoCompra = null,
  selOrcItems = [],
  user = null,
  onClose = () => {},
  onSuccess = () => {},
  pedidoCompraPedidoCotacao = null,
  filterOrcItemCategGrId = null,
}) {
  const [pedidoCompraData, setPedidoCompraData] = React.useState({});
  const [filesPedidoCompra, setFilesPedidoCompra] = React.useState([]);
  const [listaDotacoes, setListaDotacoes] = React.useState([]);
  const [valoresLimites, setValoresLimites] = React.useState([]);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [fetchedOrcItems, setFetchedOrcItems] = React.useState([]);

  const reset = React.useCallback(() => {
    setPedidoCompraData({});
    setFilesPedidoCompra([]);
    setListaDotacoes([]);
    setValoresLimites([]);
    setFetchedOrcItems([]);
  }, []);

  const getOrcDots = React.useCallback(async (orcItemId) => {
    if (!orcItemId || readOnly) {
      setListaDotacoes([]);
      setValoresLimites([]);
      return;
    }

    try {
      const resOrcDots = await oikosApi.get(`/?${qs.stringify({
        action: 'get',
        table: 'orcDot',
        data: { orcItem_id: orcItemId, orcDot_ativo: 1 },
      })}`);
      setListaDotacoes(Array.isArray(resOrcDots.data) ? resOrcDots.data : []);

      const res = await powerAppsApi.post('/', {
        acao: 'verificar_disponibilidade_orcItem',
        orcItem_id: orcItemId,
      }, {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      });
      setValoresLimites(Array.isArray(res.data) ? res.data : []);
    } catch (error) {
      console.error('Failed to fetch orcDots for pedido:', error);
      setListaDotacoes([]);
      setValoresLimites([]);
    }
  }, [readOnly]);

  React.useEffect(() => {
    if (!isOpen) return;

    let cancelled = false;

    const loadInitialData = async () => {
      try {
        setFilesPedidoCompra(Array.isArray(initialFilesPedidoCompra) ? initialFilesPedidoCompra : []);
        setListaDotacoes([]);
        setValoresLimites([]);

        if (editCompraCotacaoRow?.compraCotacao_id) {
          const compraCotacaoId = Number(editCompraCotacaoRow.compraCotacao_id) || 0;
          const pedidoCompraId = Number(
            editCompraCotacaoRow.pedidoCompra_id
            || editCompraCotacaoRow.pedidoCompra?.pedidoCompra_id,
          ) || 0;

          const cotacaoRes = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'compraCotacao',
            data: { compraCotacao_id: compraCotacaoId },
          })}`);
          const compraCotacao = cotacaoRes?.data?.[0] || editCompraCotacaoRow;

          let pedidoCompra = {};
          if (pedidoCompraId) {
            const pedidoRes = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'pedidoCompra',
              data: { pedidoCompra_id: pedidoCompraId },
            })}`);
            pedidoCompra = pedidoRes?.data?.[0] || {};
          }

          if (cancelled) return;

          setPedidoCompraData(buildCotacaoFormDataFromCompraCotacao(compraCotacao, {
            ...pedidoCompra,
            pedidoCompra_id: pedidoCompraId || pedidoCompra.pedidoCompra_id,
          }));

          const files = await fetchPedidoCompraDocuments(compraCotacaoId, 'compraCotacao');
          if (!cancelled) setFilesPedidoCompra(files);
          return;
        }

        if (editPedidoCompraRow?.pedidoCompra_id) {
          const pedidoCompraId = Number(editPedidoCompraRow.pedidoCompra_id) || 0;
          const pedidoRes = await oikosApi.get(`/?${qs.stringify({
            action: 'get',
            table: 'pedidoCompra',
            data: { pedidoCompra_id: pedidoCompraId },
            fields: {
              "(SELECT task_comentario FROM task WHERE task.task_tabRef = 'pedidoCompra' AND task.task_tabId = pedidoCompra.pedidoCompra_id AND task.task_ativo = 1 ORDER BY task.task_id DESC LIMIT 1)": 'task_comentario',
            },
          })}`);
          const pedidoCompra = pedidoRes?.data?.[0];
          if (!pedidoCompra) {
            notifyError('Nao foi possivel carregar a cotação.');
            return;
          }

          if (modoCotacao) {
            if (cotacaoParaPedidoExistente) {
              let vaga = {};
              if (showEquipePedidoCompraFields || Number(editPedidoCompraRow?.vaga_id) > 0) {
                const vagaRes = await oikosApi.get(`/?${qs.stringify({
                  action: 'get',
                  table: 'vaga',
                  data: Number(editPedidoCompraRow?.vaga_id)
                    ? { vaga_id: Number(editPedidoCompraRow.vaga_id) }
                    : { pedidoCompra_id: pedidoCompraId },
                })}`);
                vaga = vagaRes?.data?.[0] || {};
              }

              if (cancelled) return;

              const orcItemId = pedidoCompra.orcItem_id
                || vaga.orcItem_id
                || editPedidoCompraRow?.orcItem_id
                || null;

              setPedidoCompraData({
                pedidoCompra_id: pedidoCompraId,
                orcItem_id: orcItemId,
                pf_id: pedidoCompra.pf_id || editPedidoCompraRow?.pf_id || null,
                categGr_id: editPedidoCompraRow?.categGr_id || pedidoCompra.categGr_id || null,
                vaga_id: vaga.vaga_id || editPedidoCompraRow?.vaga_id || null,
                pedidoCompra_desc: '',
                compraCotacao_desc: '',
                pedidoCompra_vlrLimite: '',
                compraCotacao_vlr: '',
                compraCotacao_id: null,
                compraCotacao_link: '',
                compraCotacao_nomeInteressado: '',
              });
              setFilesPedidoCompra([]);
              if (orcItemId) getOrcDots(orcItemId);
              return;
            }

            const cotacaoRes = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'compraCotacao',
              data: { pedidoCompra_id: pedidoCompraId },
            })}`);
            const compraCotacao = cotacaoRes?.data?.[0] || {};

            let vaga = {};
            if (showEquipePedidoCompraFields || Number(editPedidoCompraRow?.vaga_id) > 0) {
              const vagaRes = await oikosApi.get(`/?${qs.stringify({
                action: 'get',
                table: 'vaga',
                data: Number(editPedidoCompraRow?.vaga_id)
                  ? { vaga_id: Number(editPedidoCompraRow.vaga_id) }
                  : { pedidoCompra_id: pedidoCompraId },
              })}`);
              vaga = vagaRes?.data?.[0] || {};
            }

            if (cancelled) return;

            setPedidoCompraData({
              ...pedidoCompra,
              ...vaga,
              vaga_id: vaga.vaga_id || editPedidoCompraRow?.vaga_id || null,
              categGr_id: editPedidoCompraRow?.categGr_id || pedidoCompra.categGr_id || null,
              orcItem_id: pedidoCompra.orcItem_id || vaga.orcItem_id || editPedidoCompraRow?.orcItem_id || null,
              pedidoCompra_desc: pedidoCompra.pedidoCompra_desc || compraCotacao.compraCotacao_desc || '',
              compraCotacao_desc: compraCotacao.compraCotacao_desc || pedidoCompra.pedidoCompra_desc || '',
              pedidoCompra_vlrLimite: pedidoCompra.pedidoCompra_vlrLimite ?? compraCotacao.compraCotacao_vlr ?? 0,
              compraCotacao_vlr: compraCotacao.compraCotacao_vlr ?? pedidoCompra.pedidoCompra_vlrLimite ?? 0,
              compraCotacao_id: compraCotacao.compraCotacao_id || null,
              compraCotacao_link: compraCotacao.compraCotacao_link || '',
              compraCotacao_nomeInteressado: compraCotacao.compraCotacao_nomeInteressado || '',
              task_comentario: pedidoCompra.task_comentario || null,
            });
            const compraCotacaoId = Number(compraCotacao.compraCotacao_id) || 0;
            const files = await fetchPedidoCompraDocuments(
              compraCotacaoId || pedidoCompraId,
              compraCotacaoId ? 'compraCotacao' : 'pedidoCompra',
            );
            if (!cancelled) {
              setFilesPedidoCompra(files);
              const orcItemId = pedidoCompra.orcItem_id
                || editPedidoCompraRow?.orcItem_id
                || null;
              if (orcItemId) getOrcDots(orcItemId);
            }
            return;
          }

          const orcItemId = pedidoCompra.orcItem_id || editPedidoCompraRow.orcItem_id;
          let orcItem = {};
          if (orcItemId) {
            const orcItemRes = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'viewRubr_OrcItem',
              fields: {
                nivel2_id: 'centroDeCustoRubr_id',
                "(SELECT categGr_id FROM categ WHERE categ.categ_id = viewRubr_OrcItem.categ_id LIMIT 1)": 'categGr_id',
                "(SELECT pf_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)": 'pf_id',
                "(SELECT contratoForn_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)": 'contratoForn_id',
                "(SELECT orcItem_original FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1)": 'orcItem_original',
                "(SELECT projAtuacao_id FROM projAtuacao WHERE projAtuacao.projAtuacao_id = (SELECT projAtuacao_id FROM propOrcItem WHERE propOrcItem.propOrcItem_id = (SELECT propOrcItem_id FROM orcItem WHERE orcItem.orcItem_id = viewRubr_OrcItem.orcItem_id LIMIT 1) LIMIT 1) LIMIT 1)": 'projAtuacao_id',
              },
              data: { orcItem_id: orcItemId },
            })}`);
            orcItem = orcItemRes?.data?.[0] || {};
          }

          let vaga = {};
          const shouldFetchVaga = !modoCotacao && (
            showEquipePedidoCompraFields
            || Number(orcItem.categGr_id) === EQUIPE_CATEG_GR_ID
            || Number(editPedidoCompraRow?.vaga_id) > 0
          );
          if (shouldFetchVaga) {
            const vagaId = Number(editPedidoCompraRow?.vaga_id) || 0;
            const vagaRes = await oikosApi.get(`/?${qs.stringify({
              action: 'get',
              table: 'vaga',
              data: vagaId ? { vaga_id: vagaId } : { pedidoCompra_id: pedidoCompraId },
            })}`);
            vaga = vagaRes?.data?.[0] || {};
          }

          if (cancelled) return;

          setPedidoCompraData(buildPedidoCompraFormDataForEdit(pedidoCompra, vaga, orcItem));
          const files = await fetchPedidoCompraDocuments(
            pedidoCompraId,
            'pedidoCompra',
          );
          if (!cancelled) {
            setFilesPedidoCompra(files);
            if (orcItemId) getOrcDots(orcItemId);
          }
          return;
        }

        if (compraCotacaoParaPedidoCompra?.compraCotacao_id) {
          if (cancelled) return;

          setPedidoCompraData({
            pedidoCompra_desc: compraCotacaoParaPedidoCompra.compraCotacao_desc || '',
            pedidoCompra_vlrLimite: compraCotacaoParaPedidoCompra.compraCotacao_vlr ?? 0,
            compraCotacao_id_vinculo: compraCotacaoParaPedidoCompra.compraCotacao_id,
            ...(initialPedidoCompraData || {}),
          });
          return;
        }

        const nextData = initialPedidoCompraData || {};
        setPedidoCompraData(nextData);
        if (nextData.orcItem_id) {
          getOrcDots(nextData.orcItem_id);
        }
      } catch (e) {
        notifyError('Erro ao carregar cotação para edicao.');
        console.log('Erro ao abrir edicao do pedidoCompra:', e);
      }
    };

    loadInitialData();

    return () => {
      cancelled = true;
    };
  }, [
    editCompraCotacaoRow,
    editPedidoCompraRow,
    compraCotacaoParaPedidoCompra,
    getOrcDots,
    initialFilesPedidoCompra,
    initialPedidoCompraData,
    isOpen,
    showEquipePedidoCompraFields,
    modoCotacao,
    cotacaoParaPedidoExistente,
  ]);

  const close = React.useCallback(() => {
    reset();
    onClose();
  }, [onClose, reset]);

  React.useEffect(() => {
    if (!isOpen || hideCentroDeCusto || readOnly || modoCotacao) {
      setFetchedOrcItems([]);
      return;
    }

    const centroDeCustoRubrId = Number(pedidoCompraData.centroDeCustoRubr_id) || 0;
    if (!centroDeCustoRubrId) {
      setFetchedOrcItems([]);
      return;
    }

    let cancelled = false;

    fetchOrcItemsForCentroDeCusto(centroDeCustoRubrId, { categGrId: filterOrcItemCategGrId })
      .then((items) => {
        if (!cancelled) setFetchedOrcItems(items);
      })
      .catch((error) => {
        console.error('Erro ao carregar itens orcamentarios:', error);
        if (!cancelled) setFetchedOrcItems([]);
      });

    return () => {
      cancelled = true;
    };
  }, [isOpen, hideCentroDeCusto, readOnly, modoCotacao, pedidoCompraData.centroDeCustoRubr_id, filterOrcItemCategGrId]);

  const resolvedSelOrcItems = React.useMemo(() => {
    const baseItems = hideCentroDeCusto
      ? (Array.isArray(selOrcItems) ? selOrcItems : [])
      : fetchedOrcItems;
    const extraItems = [
      ...(Array.isArray(selOrcItems) ? selOrcItems : []),
      ...(pedidoCompraData?.orcItem_id && pedidoCompraData?.orcItem_desc
        ? [{
          value: pedidoCompraData.orcItem_id,
          label: pedidoCompraData.orcItem_desc,
          nivel2_id: pedidoCompraData.centroDeCustoRubr_id,
          projAtuacao_id: pedidoCompraData.projAtuacao_id,
          categGr_id: pedidoCompraData.categGr_id,
        }]
        : []),
    ];

    const uniqueItems = [...baseItems, ...extraItems].filter((item, index, items) => (
      item?.value
      && items.findIndex((candidate) => Number(candidate.value) === Number(item.value)) === index
    ));
    const categGrFilter = Number(filterOrcItemCategGrId) || 0;
    if (!categGrFilter) return uniqueItems;
    return uniqueItems.filter((item) => Number(item.categGr_id) === categGrFilter);
  }, [
    filterOrcItemCategGrId,
    hideCentroDeCusto,
    selOrcItems,
    fetchedOrcItems,
    pedidoCompraData.orcItem_id,
    pedidoCompraData.orcItem_desc,
    pedidoCompraData.centroDeCustoRubr_id,
    pedidoCompraData.projAtuacao_id,
    pedidoCompraData.categGr_id,
  ]);

  const isEquipePedidoCompra = React.useMemo(() => {
    const selectedOrcItem = resolvedSelOrcItems.find(
      (item) => Number(item.value) === Number(pedidoCompraData.orcItem_id),
    );
    return showEquipePedidoCompraFields
      || Number(pedidoCompraData.categGr_id) === EQUIPE_CATEG_GR_ID
      || Number(selectedOrcItem?.categGr_id) === EQUIPE_CATEG_GR_ID
      || Number(pedidoCompraData.vaga_id) > 0
      || Number(editPedidoCompraRow?.vaga_id) > 0;
  }, [
    editPedidoCompraRow?.vaga_id,
    pedidoCompraData.categGr_id,
    pedidoCompraData.orcItem_id,
    pedidoCompraData.vaga_id,
    resolvedSelOrcItems,
    showEquipePedidoCompraFields,
  ]);

  const submitPedidoCompra = React.useCallback(async () => {
    if (modoCotacao) {
      if (!pedidoCompraData?.pedidoCompra_desc?.trim()) {
        notifyError('Preencha a descricao da cotacao.');
        return;
      }

      try {
        setIsSubmitting(true);
        const descricao = pedidoCompraData.pedidoCompra_desc.trim();
        const valorEstimado = pedidoCompraData.pedidoCompra_vlrLimite || 0;
        const compraCotacaoLink = pedidoCompraData.compraCotacao_link?.trim() || undefined;
        const compraCotacaoNomeInteressado = pedidoCompraData.compraCotacao_nomeInteressado?.trim() || undefined;

        const compraCotacaoPayload = {
          compraCotacao_desc: descricao,
          compraCotacao_vlr: valorEstimado,
          compraCotacao_link: compraCotacaoLink,
          compraCotacao_nomeInteressado: compraCotacaoNomeInteressado,
        };

        if (cotacaoParaPedidoExistente) {
          const pedidoCompraId = Number(pedidoCompraData.pedidoCompra_id) || 0;
          if (!pedidoCompraId) {
            notifyError('Nao foi possivel identificar a cotação.');
            return;
          }

          const insertResponse = await oikosApi.post('/', {
            action: 'insert',
            table: 'compraCotacao',
            data: {
              pedidoCompra_id: pedidoCompraId,
              ...compraCotacaoPayload,
              compraStatus_id: 1,
              compraCotacao_dtCotacao: moment().format('YYYY-MM-DD'),
            },
          });
          const newCompraCotacaoId = Number(insertResponse?.data?.[0]?.compraCotacao_id) || 0;

          if (newCompraCotacaoId && filesPedidoCompra.length > 0) {
            await savePedidoCompraOuVagaDocuments(filesPedidoCompra, newCompraCotacaoId, 'compraCotacao');
          }

          if (isEquipePedidoCompra && newCompraCotacaoId) {
            const vagaId = await resolveVagaIdForEquipePedidoCompra({
              pedidoCompraData,
              editPedidoCompraRow,
            });
            if (!vagaId) {
              notifyError('Cotação criada, mas não foi possível identificar a vaga para cadastrar o candidato.');
              return;
            }

            await insertCandidatoFromCompraCotacao({
              vagaId,
              compraCotacaoId: newCompraCotacaoId,
              nome: compraCotacaoNomeInteressado,
              valorSalario: valorEstimado,
              userId: user?.pf_id,
            });
          }

          await onSuccess?.({
            pedidoCompra_id: pedidoCompraId,
            compraCotacao_id: newCompraCotacaoId,
            pedidoCompraData,
            modoCotacao: true,
            cotacaoParaPedidoExistente: true,
          });
          close();
          notifySuccess('Cotacao cadastrada com sucesso.');
          return;
        }

        const compraCotacaoId = Number(pedidoCompraData.compraCotacao_id) || 0;
        const isEditingCompraCotacao = Boolean(compraCotacaoId);

        if (isEditingCompraCotacao) {
          await oikosApi.post('/', {
            action: 'update',
            table: 'compraCotacao',
            data: {
              compraCotacao_id: compraCotacaoId,
              ...compraCotacaoPayload,
            },
          });

          if (filesPedidoCompra.length > 0) {
            await savePedidoCompraOuVagaDocuments(filesPedidoCompra, compraCotacaoId, 'compraCotacao');
          }

          await onSuccess?.({ compraCotacao_id: compraCotacaoId, pedidoCompraData, modoCotacao: true });
          close();
          notifySuccess('Cotacao atualizada com sucesso.');
          return;
        }

        const response = await oikosApi.post('/', {
          action: 'insert',
          table: 'compraCotacao',
          data: {
            ...compraCotacaoPayload,
            compraStatus_id: 6,
            compraCotacao_dtCotacao: moment().format('YYYY-MM-DD'),
          },
        });
        const newCompraCotacaoId = Number(response?.data?.[0]?.compraCotacao_id) || 0;

        if (newCompraCotacaoId && filesPedidoCompra.length > 0) {
          await savePedidoCompraOuVagaDocuments(filesPedidoCompra, newCompraCotacaoId, 'compraCotacao');
        }

        await onSuccess?.({
          compraCotacao_id: newCompraCotacaoId,
          pedidoCompraData,
          modoCotacao: true,
        });
        close();
        notifySuccess('Cotacao cadastrada com sucesso.');
      } catch (e) {
        notifyError('Erro ao cadastrar cotacao.');
        console.log('Erro ao inserir cotacao:', e);
      } finally {
        setIsSubmitting(false);
      }
      return;
    }

    if (!allowPedidoSemOrcItem && !pedidoCompraData?.orcItem_id) {
      notifyError('Nao foi possivel identificar o item orcamentario.');
      return;
    }

    if (!pedidoCompraData?.pedidoCompra_desc?.trim()) {
      notifyError('Preencha a descricao da cotação.');
      return;
    }

    try {
      setIsSubmitting(true);
      const pedidoCompraId = Number(pedidoCompraData.pedidoCompra_id) || 0;
      const isEditing = Boolean(pedidoCompraId);
      const selectedOrcItem = selOrcItems.find(
        (item) => Number(item.value) === Number(pedidoCompraData?.orcItem_id),
      );
      const orcItemPfId = Number(selectedOrcItem?.pf_id || pedidoCompraData.pf_id) || 0;

      if (pedidoCompraData?.orcItem_id && !orcItemPfId) {
        notifyError('Item orçamentário sem responsável');
        setIsSubmitting(false);
        return;
      }

      // pf_id do pedidoCompra só é preenchido quando há orcItem, com o pf_id desse orcItem.
      const pfId = pedidoCompraData?.orcItem_id ? orcItemPfId : undefined;

      const pedidoCompraPayload = {
        orcItem_id: pedidoCompraData.orcItem_id || undefined,
        pedidoCompra_vlrLimite: pedidoCompraData.pedidoCompra_vlrLimite || 0,
        pedidoCompra_dtLimiteEntrega: pedidoCompraData.pedidoCompra_dtLimiteEntrega || undefined,
        pedidoCompra_dtVigIni: pedidoCompraData.pedidoCompra_dtVigIni || undefined,
        pedidoCompra_dtVigFim: pedidoCompraData.pedidoCompra_dtVigFim || undefined,
        pedidoCompra_desc: pedidoCompraData.pedidoCompra_desc.trim(),
        pedidoCompraStatus_id: PEDIDO_COMPRA_STATUS_APROVADO,
        ...(pfId ? { pf_id: pfId } : {}),
        // Não gravamos mais um pedidoCompraTp_id específico de "vaga": o categGr_id
        // do orcItem vinculado já identifica que o pedidoCompra se refere a uma vaga.
        ...(pedidoCompraPedidoCotacao == null
          ? {}
          : { pedidoCompra_pedidoCotacao: Number(pedidoCompraPedidoCotacao) ? 1 : 0 }),
      };

      if (isEditing) {
        await oikosApi.post('/', {
          action: 'update',
          table: 'pedidoCompra',
          data: {
            pedidoCompra_id: pedidoCompraId,
            ...pedidoCompraPayload,
          },
        });

        if (filesPedidoCompra.length > 0) {
          await savePedidoCompraOuVagaDocuments(filesPedidoCompra, pedidoCompraId, 'pedidoCompra');
        }

        if (isEquipePedidoCompra) {
          await updateVaga({ ...pedidoCompraData, pedidoCompra_id: pedidoCompraId });
        }

        await onSuccess?.({ pedidoCompra_id: pedidoCompraId, pedidoCompraData, isEquipePedidoCompra });
        close();
        notifySuccess(`${isEquipePedidoCompra ? 'Vaga' : 'Cotação'} aprovado com sucesso.`);
        return;
      }

      const response = await oikosApi.post('/', {
        action: 'insert',
        table: 'pedidoCompra',
        data: {
          ...pedidoCompraPayload,
          pedidoCompra_dtSolicitacao: moment().format('YYYY-MM-DD'),
        },
      });
      const newPedidoCompraId = response?.data?.[0]?.pedidoCompra_id;

      const compraCotacaoIdVinculo = Number(
        compraCotacaoParaPedidoCompra?.compraCotacao_id
        || pedidoCompraData.compraCotacao_id_vinculo,
      ) || 0;

      if (compraCotacaoIdVinculo && newPedidoCompraId) {
        await oikosApi.post('/', {
          action: 'update',
          table: 'compraCotacao',
          data: {
            compraCotacao_id: compraCotacaoIdVinculo,
            pedidoCompra_id: newPedidoCompraId,
            compraStatus_id: COMPRA_STATUS_ABERTO,
          },
        });
      }

      if (newPedidoCompraId && filesPedidoCompra.length > 0) {
        await savePedidoCompraOuVagaDocuments(filesPedidoCompra, newPedidoCompraId, 'pedidoCompra');
      }

      if (isEquipePedidoCompra && newPedidoCompraId) {
        await updateVaga({ ...pedidoCompraData, pedidoCompra_id: newPedidoCompraId });
      }

      await onSuccess?.({
        pedidoCompra_id: newPedidoCompraId,
        pedidoCompraData,
        isEquipePedidoCompra,
        compraCotacao_id_vinculo: compraCotacaoIdVinculo || undefined,
      });
      close();
      notifySuccess(
        compraCotacaoIdVinculo
          ? 'Cotação criada e proposta vinculada com sucesso.'
          : `${isEquipePedidoCompra ? 'Vaga' : 'Cotação'} aprovado com sucesso.`,
      );
    } catch (e) {
      notifyError(`Erro ao cadastrar ${isEquipePedidoCompra ? 'vaga' : 'cotação'}.`);
      console.log(`Erro ao inserir ${isEquipePedidoCompra ? 'vaga' : 'cotação'}:`, e);
    } finally {
      setIsSubmitting(false);
    }
  }, [
    allowPedidoSemOrcItem,
    close,
    compraCotacaoParaPedidoCompra,
    cotacaoParaPedidoExistente,
    editPedidoCompraRow,
    filesPedidoCompra,
    isEquipePedidoCompra,
    modoCotacao,
    onSuccess,
    pedidoCompraData,
    pedidoCompraPedidoCotacao,
    user,
  ]);

  return {
    pedidoCompraData,
    setPedidoCompraData,
    filesPedidoCompra,
    setFilesPedidoCompra,
    listaDotacoes,
    setListaDotacoes,
    valoresLimites,
    getOrcDots,
    submitPedidoCompra,
    isSubmitting,
    isEquipePedidoCompra,
    resolvedSelOrcItems,
    close,
  };
}

export function PedidoCompraForm({
  pedidoCompraData = {},
  setPedidoCompraData = () => {},
  selCentroDeCusto = [],
  selOrcItems = [],
  selPropItems = [],
  listaDotacoes = [],
  setListaDotacoes = () => {},
  filteredValoresLimites = [],
  valoresLimites = [],
  filesPedidoCompra = [],
  setFilesPedidoCompra = () => {},
  getOrcDots = () => {},
  hideCentroDeCusto = false,
  hideOrcItem = false,
  hidePropItem = false,
  hideQuantidadeOportunidades = false,
  valorEstimadoDisabled = false,
  hideValorEstimado = false,
  hideDtLimite = false,
  hideAnexos = false,
  showEquipePedidoCompraFields = false,
  allowPedidoSemOrcItem = false,
  readOnly = false,
  readOnlyOrcItem = false,
  contratoDtAssin = null,
  contratoPrazoVigencia = null,
  contratoPrazoVigenciaAditivo = null,
  vagaTipo = '',
  onVagaTipoChange = () => {},
  selOrcItemsOriginais = [],
  isLoadingOrcItemsOriginais = false,
  showContratacaoRadios = false,
  isResubmitMode = false,
  modoCotacao = false,
}) {
  const [municipios, setMunicipios] = React.useState([]);
  const [ufs, setUfs] = React.useState([]);
  const [projAtuacoes, setProjAtuacoes] = React.useState([]);
  const [profissoes, setProfissoes] = React.useState([]);
  const [documentosObrigatorios, setDocumentosObrigatorios] = React.useState([]);

  const selectedOrcItem = React.useMemo(
    () => selOrcItems.find((item) => Number(item.value) === Number(pedidoCompraData.orcItem_id)) || null,
    [selOrcItems, pedidoCompraData.orcItem_id],
  );

  const showEquipeFields = showEquipePedidoCompraFields
    || Number(selectedOrcItem?.categGr_id) === EQUIPE_CATEG_GR_ID;

  const showEquipeDetailFields = showEquipeFields
    && (!showContratacaoRadios || vagaTipo === 'interno' || vagaTipo === 'externo');

  const showFormFieldsAfterContratacao = !showContratacaoRadios
    || vagaTipo === 'interno'
    || vagaTipo === 'externo';

  const selectedUf = React.useMemo(() => (
    ufs.find(uf => Number(uf.value) === Number(pedidoCompraData.vagaEstado)) || null
  ), [ufs, pedidoCompraData.vagaEstado]);

  const filteredMunicipios = React.useMemo(() => {
    if (!selectedUf?.uf_IBGECod) return [];
    return municipios.filter(
      (municipio) => String(municipio.uf_IBGECod) === String(selectedUf.uf_IBGECod),
    );
  }, [municipios, selectedUf]);

  const internalFilteredDotacoes = React.useMemo(() => {
    const { pedidoCompra_dtVigIni, pedidoCompra_dtVigFim } = pedidoCompraData;
    if (!pedidoCompra_dtVigIni || !pedidoCompra_dtVigFim) return [];
    const [sY, sM] = pedidoCompra_dtVigIni.split('-').map(Number);
    const [eY, eM] = pedidoCompra_dtVigFim.split('-').map(Number);
    const startYM = sY * 100 + sM;
    const endYM = eY * 100 + eM;
    if (startYM > endYM) return [];
    return listaDotacoes.filter(({ orcDot_data }) => {
      if (!orcDot_data) return false;
      const [y, m] = orcDot_data.split('-').map(Number);
      if (!Number.isFinite(y) || !Number.isFinite(m)) return false;
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [pedidoCompraData.pedidoCompra_dtVigIni, pedidoCompraData.pedidoCompra_dtVigFim, listaDotacoes]);

  const internalFilteredValoresLimites = React.useMemo(() => {
    const { pedidoCompra_dtVigIni, pedidoCompra_dtVigFim } = pedidoCompraData;
    if (!pedidoCompra_dtVigIni || !pedidoCompra_dtVigFim) return [];
    const [sY, sM] = pedidoCompra_dtVigIni.split('-').map(Number);
    const [eY, eM] = pedidoCompra_dtVigFim.split('-').map(Number);
    const startYM = sY * 100 + sM;
    const endYM = eY * 100 + eM;
    if (startYM > endYM) return [];
    return valoresLimites.filter(({ mes }) => {
      if (!mes) return false;
      const [y, m] = mes.split('-').map(Number);
      if (!Number.isFinite(y) || !Number.isFinite(m)) return false;
      const itemYM = y * 100 + m;
      return itemYM >= startYM && itemYM <= endYM;
    });
  }, [pedidoCompraData.pedidoCompra_dtVigIni, pedidoCompraData.pedidoCompra_dtVigFim, valoresLimites]);

  const resumoOrcamentoPorAno = React.useMemo(() => buildResumoOrcamentoPorAno({
    dtIni: pedidoCompraData.pedidoCompra_dtVigIni,
    dtFim: pedidoCompraData.pedidoCompra_dtVigFim,
    listaDotacoes,
    valoresLimites,
  }), [
    pedidoCompraData.pedidoCompra_dtVigIni,
    pedidoCompraData.pedidoCompra_dtVigFim,
    listaDotacoes,
    valoresLimites,
  ]);

  const vigenciaDatasInvalidas = React.useMemo(() => isVigenciaDatasInvalidas(
    pedidoCompraData.pedidoCompra_dtVigIni,
    pedidoCompraData.pedidoCompra_dtVigFim,
  ), [pedidoCompraData.pedidoCompra_dtVigIni, pedidoCompraData.pedidoCompra_dtVigFim]);

  React.useEffect(() => {
    if (readOnly) return;
    if (isResubmitMode) return;
    if (!pedidoCompraData.pedidoCompra_dtVigIni || !pedidoCompraData.pedidoCompra_dtVigFim) return;
    const valorDisponivel = internalFilteredValoresLimites.reduce(
      (acc, cur) => Number(acc) + Number(cur.disponivel || 0),
      0,
    );
    setPedidoCompraData((prev) => ({ ...prev, pedidoCompra_vlrLimite: valorDisponivel }));
  }, [internalFilteredValoresLimites, isResubmitMode, pedidoCompraData.pedidoCompra_dtVigIni, pedidoCompraData.pedidoCompra_dtVigFim, readOnly, setPedidoCompraData]);

  React.useEffect(() => {
    if (readOnly) return;
    if (!pedidoCompraData.vagaCidade) return;
    if (municipios.length === 0 || ufs.length === 0) return;
    if (!pedidoCompraData.vagaEstado || !selectedUf?.uf_IBGECod) return;
    if (filteredMunicipios.some((municipio) => Number(municipio.value) === Number(pedidoCompraData.vagaCidade))) return;

    setPedidoCompraData((prev) => ({
      ...prev,
      vagaCidade: null,
      vaga_localidadeCidade: null,
    }));
  }, [
    readOnly,
    filteredMunicipios,
    municipios.length,
    ufs.length,
    pedidoCompraData.vagaCidade,
    pedidoCompraData.vagaEstado,
    selectedUf,
    setPedidoCompraData,
  ]);

  const contratoFimVigencia = contratoPrazoVigenciaAditivo || contratoPrazoVigencia;

  const dataInicioVigenciaError = (
    isDateBefore(pedidoCompraData.pedidoCompra_dtVigIni, contratoDtAssin)
  ) ? CONTRATO_DATE_ERROR_MESSAGE : null;

  const dataFimVigenciaError = (
    isDateAfter(pedidoCompraData.pedidoCompra_dtVigFim, contratoFimVigencia)
  ) ? CONTRATO_DATE_ERROR_MESSAGE : null;

  React.useEffect(() => {
    if (!showEquipeFields) return;

    async function loadEquipeOptions() {
      try {
        const requests = [
          selectValues('mun', 'mun_id', 'mun_nome', {}, { uf_IBGECod: 'uf_IBGECod' }),
          selectValues('uf', 'uf_id', 'uf_nome', {}, { uf_IBGECod: 'uf_IBGECod' }),
          selectValues('projAtuacao', 'projAtuacao_id', 'projAtuacao_nome'),
          selectValues('profissao', 'profissao_id', 'profissao_nome'),
        ];
        if (showEquipePedidoCompraFields) {
          requests.push(fetchDocumentosObrigatoriosTpDocumentoOptions());
        }

        const [
          municipiosOptions,
          ufsOptions,
          projAtuacoesOptions,
          profissoesOptions,
          documentosObrigatoriosOptions,
        ] = await Promise.all(requests);

        setMunicipios(Array.isArray(municipiosOptions) ? municipiosOptions : []);
        setUfs(Array.isArray(ufsOptions) ? ufsOptions : []);
        setProjAtuacoes(Array.isArray(projAtuacoesOptions) ? projAtuacoesOptions : []);
        setProfissoes(Array.isArray(profissoesOptions) ? profissoesOptions : []);
        setDocumentosObrigatorios(
          showEquipePedidoCompraFields && Array.isArray(documentosObrigatoriosOptions)
            ? documentosObrigatoriosOptions
            : [],
        );
      } catch (e) {
        console.log('Erro ao carregar municipios/ufs da cotação:', e);
      }
    }

    loadEquipeOptions();
  }, [showEquipeFields, showEquipePedidoCompraFields]);

  React.useEffect(() => {
    if (readOnly || !showEquipeDetailFields) return;

    const projAtuacaoId = Number(
      pedidoCompraData.projAtuacao_id || selectedOrcItem?.projAtuacao_id,
    ) || 0;
    if (!projAtuacaoId || projAtuacoes.length === 0) return;
    if (pedidoCompraData.vaga_cargo || pedidoCompraData.vagaCargo) return;

    const plannedAtuacao = projAtuacoes.find(
      (projAtuacao) => Number(projAtuacao.value) === projAtuacaoId,
    );
    if (!plannedAtuacao) return;

    setPedidoCompraData((prev) => ({
      ...prev,
      projAtuacao_id: projAtuacaoId,
      vagaCargo: plannedAtuacao.label,
      vaga_cargo: plannedAtuacao.label,
    }));
  }, [
    readOnly,
    showEquipeDetailFields,
    pedidoCompraData.projAtuacao_id,
    pedidoCompraData.vaga_cargo,
    pedidoCompraData.vagaCargo,
    selectedOrcItem?.projAtuacao_id,
    projAtuacoes,
    setPedidoCompraData,
  ]);

  if (modoCotacao) {
    return (
      <Row>
        {isResubmitMode && pedidoCompraData.task_comentario && (
          <Col sm={12}>
            <FormGroup>
              <Label>Comentario da aprovacao</Label>
              <Input
                type="textarea"
                rows={3}
                value={pedidoCompraData.task_comentario}
                disabled
                readOnly
              />
            </FormGroup>
          </Col>
        )}

        <Col sm={12}>
          <FormGroup>
            <Label>Descrição</Label>
            <Input
              type="textarea"
              placeholder="Escreva a descrição da cotação"
              disabled={readOnly}
              value={pedidoCompraData.pedidoCompra_desc || ''}
              onChange={(e) => {
                const descricao = e.target.value;
                setPedidoCompraData({
                  ...pedidoCompraData,
                  pedidoCompra_desc: descricao,
                  compraCotacao_desc: descricao,
                });
              }}
            />
          </FormGroup>
        </Col>

        <Col sm={12}>
          <FormGroup>
            <div className="d-flex align-items-center" style={{ marginBottom: -4 }}>
              <Label>Nome do vendedor/prestador</Label>
              <FormInputTooltip text="Nome da parte interessada na compra. Exemplo: Mercado Livre, Amazon, etc" />
            </div>
            <Input
              type="text"
              placeholder="Ex.: Mercado Livre, Amazon"
              disabled={readOnly}
              value={pedidoCompraData.compraCotacao_nomeInteressado || ''}
              onChange={(e) => {
                setPedidoCompraData({
                  ...pedidoCompraData,
                  compraCotacao_nomeInteressado: e.target.value,
                });
              }}
            />
          </FormGroup>
        </Col>

        <Col sm={12}>
          <FormGroup>
            <Label>Valor estimado</Label>
            <MaskedInput
              unmask
              mask="R$ num"
              disabled={valorEstimadoDisabled || readOnly}
              blocks={{
                num: {
                  mask: Number,
                  scale: 2,
                  signed: false,
                  thousandsSeparator: '.',
                  padFractionalZeros: false,
                  normalizeZeros: false,
                  radix: ',',
                  min: 0,
                  max: 1000000000,
                },
              }}
              lazy={false}
              value={String(pedidoCompraData.pedidoCompra_vlrLimite ?? '')}
              onAccept={(value) => {
                if (!valorEstimadoDisabled && !readOnly) {
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    pedidoCompra_vlrLimite: value,
                    compraCotacao_vlr: value,
                  });
                }
              }}
            />
          </FormGroup>
        </Col>

        <Col sm={12}>
          <FormGroup>
            <Label>Link</Label>
            <Input
              type="url"
              placeholder="https://"
              disabled={readOnly}
              value={pedidoCompraData.compraCotacao_link || ''}
              onChange={(e) => {
                setPedidoCompraData({ ...pedidoCompraData, compraCotacao_link: e.target.value });
              }}
            />
          </FormGroup>
        </Col>

        {!hideAnexos && (
          <Col sm={12}>
            <FormGroup>
              <Label>Anexos complementares</Label>
              <AddFiles
                multiple={true}
                readOnly={readOnly}
                files={filesPedidoCompra}
                onFilesChange={readOnly ? () => {} : setFilesPedidoCompra}
              />
            </FormGroup>
          </Col>
        )}
      </Row>
    );
  }

  return (
    <Row>
      {isResubmitMode && pedidoCompraData.task_comentario && (
        <Col sm={12}>
          <FormGroup>
            <Label>Comentario da aprovacao</Label>
            <Input
              type="textarea"
              rows={3}
              value={pedidoCompraData.task_comentario}
              disabled
              readOnly
            />
          </FormGroup>
        </Col>
      )}

      {!hideCentroDeCusto && (
        <Col sm={3}>
          <FormGroup>
            <Label>
              Centro de custo
            </Label>
            <Select
              classNamePrefix="select2-selection"
              placeholder="Selecione um item"
              isClearable={allowPedidoSemOrcItem && !readOnlyOrcItem}
              isDisabled={readOnly || readOnlyOrcItem}
              value={pedidoCompraData.centroDeCustoRubr_id ? selCentroDeCusto.filter(x => (x.value === pedidoCompraData.centroDeCustoRubr_id)) : null}
              options={selCentroDeCusto}
              onChange={(e) => {
                setPedidoCompraData({ ...pedidoCompraData, centroDeCustoRubr_id: e?.value ?? null, orcItem_id: null });
                setListaDotacoes([]);
              }}
            />
          </FormGroup>
        </Col>
      )}

      {!hideOrcItem && (
        <Col sm={hideCentroDeCusto ? 12 : 9}>
          <FormGroup>
            <Label>
              Item orçamentário
            </Label>
            <Select
              classNamePrefix="select2-selection"
              placeholder="Selecione um item"
              isClearable={allowPedidoSemOrcItem}
              isDisabled={readOnlyOrcItem || readOnly}
              value={pedidoCompraData.orcItem_id ? selOrcItems.filter(x => (x.value === pedidoCompraData.orcItem_id)) : null}
              options={selOrcItems}
              onChange={(e) => {
                const newOrcItemId = e?.value ?? null;
                const newOrcItem = selOrcItems.find((item) => Number(item.value) === Number(newOrcItemId));
                if (newOrcItemId && !Number(newOrcItem?.pf_id)) {
                  notifyError('Item orçamentário sem responsável');
                  return;
                }
                const isEquipeItem = Number(newOrcItem?.categGr_id) === EQUIPE_CATEG_GR_ID;

                setPedidoCompraData({
                  ...pedidoCompraData,
                  orcItem_id: newOrcItemId,
                  pf_id: newOrcItemId ? (Number(newOrcItem?.pf_id) || null) : null,
                  projAtuacao_id: newOrcItem?.projAtuacao_id ?? null,
                  vagaCargo: '',
                  vaga_cargo: '',
                  contratoForn_id: null,
                  contratoForn_idLocked: false,
                  contratoForn_label: null,
                });
                getOrcDots(newOrcItemId);

                if (showContratacaoRadios && !showEquipePedidoCompraFields && !isEquipeItem) {
                  onVagaTipoChange('');
                }
              }}
            />
          </FormGroup>
        </Col>
      )}

      {showContratacaoRadios && pedidoCompraData.orcItem_id && (
        <Col sm={12}>
          <FormGroup tag="fieldset" className="mb-3">
            <legend className="col-form-label pt-0">Tipo de contratação</legend>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="vagaTipo"
                  checked={vagaTipo === 'interno'}
                  onChange={() => onVagaTipoChange('interno')}
                  disabled={readOnly}
                />
                {' '}Contratar membro para equipe do projeto
              </Label>
            </FormGroup>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="vagaTipo"
                  checked={vagaTipo === 'externo'}
                  onChange={() => onVagaTipoChange('externo')}
                  disabled={readOnly}
                />
                {' '}Contratar consultor
              </Label>
            </FormGroup>
          </FormGroup>
          {vagaTipo === 'interno' && (
            <FormGroup>
              <Label>Item orçamentário de origem</Label>
              {isLoadingOrcItemsOriginais ? (
                <div className="d-flex align-items-center">
                  <Spinner size="sm" className="mr-2" />
                  <span className="text-muted">Carregando itens orçamentários...</span>
                </div>
              ) : (
                <Select
                  value={selOrcItemsOriginais.find(
                    (option) => String(option.value) === String(pedidoCompraData.orcItem_original),
                  ) || null}
                  options={selOrcItemsOriginais}
                  onChange={(option) => {
                    if (readOnly) return;
                    setPedidoCompraData((prev) => ({
                      ...prev,
                      orcItem_original: option?.value ?? null,
                    }));
                  }}
                  isDisabled={readOnly}
                  placeholder="Selecione o item orçamentário de origem"
                />
              )}
            </FormGroup>
          )}
        </Col>
      )}

      {showFormFieldsAfterContratacao && !hidePropItem && (
        <Col sm={6}>
          <FormGroup>
            <Label>
              Item da proposta
            </Label>
            <Select
              classNamePrefix="select2-selection"
              placeholder="Selecione um item"
              isDisabled={readOnly}
              value={pedidoCompraData.propItem_id ? selPropItems.filter(x => (x.value === pedidoCompraData.propItem_id)) : null}
              options={selPropItems}
              onChange={(e) => {
                setPedidoCompraData({ ...pedidoCompraData, propItem_id: e?.value ?? null });
              }}
            />
          </FormGroup>
        </Col>
      )}

      {showFormFieldsAfterContratacao && !hideQuantidadeOportunidades && (
        <Col sm={4}>
          <FormGroup>
            <Label>
              Quantidade de oportunidades
            </Label>
            <Input
              type="number"
              placeholder="Quantidade"
              disabled={readOnly}
              value={pedidoCompraData.quantidade ? pedidoCompraData.quantidade : null}
              onChange={(e) => { setPedidoCompraData({ ...pedidoCompraData, quantidade: e.target.value }); }}
            />
          </FormGroup>
        </Col>
      )}

      {showFormFieldsAfterContratacao && !hideDtLimite && (
        <Col sm={4}>
          <FormGroup>
            <Label>
              Data limite para proposta
            </Label>
            <DatePicker
              placeholderText="__/__/_____"
              locale="pt-BR"
              className="form-control"
              dateFormat="dd/MM/yyyy"
              peekNextMonth
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              disabled={readOnly}
              selected={pedidoCompraData.pedidoCompra_dtLimiteEntrega ? moment(pedidoCompraData.pedidoCompra_dtLimiteEntrega).toDate() : null}
              onChange={date => {
                if (readOnly) return;
                if (date) {
                  return setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_dtLimiteEntrega: moment(date).format('YYYY-MM-DD'), vaga_dtLimiteEntrega: moment(date).format('YYYY-MM-DD') });
                }
                return setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_dtLimiteEntrega: undefined, vaga_dtLimiteEntrega: undefined });
              }}
            />
          </FormGroup>
        </Col>
      )}

      {showFormFieldsAfterContratacao && pedidoCompraData.orcItem_id && (
        <>
          <Col sm={4}>
            <FormGroup>
              <Label>Data início prestação do serviço</Label>
              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                disabled={readOnly}
                selected={pedidoCompraData.pedidoCompra_dtVigIni ? moment(pedidoCompraData.pedidoCompra_dtVigIni).toDate() : null}
                onChange={date => {
                  if (readOnly) return;
                  if (date) {
                    setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_dtVigIni: moment(date).format('YYYY-MM-DD'), vaga_dtVigIni: moment(date).format('YYYY-MM-DD') });
                  } else {
                    setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_dtVigIni: null, vaga_dtVigIni: null });
                  }
                }}
              />
              {dataInicioVigenciaError && (
                <div style={{ color: '#dc3545', marginTop: 4 }}>
                  {}
                  {dataInicioVigenciaError}
                </div>
              )}
            </FormGroup>
          </Col>
          <Col sm={4}>
            <FormGroup>
              <Label>Data fim prestação do serviço</Label>
              <DatePicker
                placeholderText="__/__/_____"
                locale="pt-BR"
                className="form-control"
                dateFormat="dd/MM/yyyy"
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                disabled={readOnly}
                selected={pedidoCompraData.pedidoCompra_dtVigFim ? moment(pedidoCompraData.pedidoCompra_dtVigFim).toDate() : null}
                onChange={date => {
                  if (readOnly) return;
                  if (date) {
                    setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_dtVigFim: moment(date).format('YYYY-MM-DD'), vaga_dtVigFim: moment(date).format('YYYY-MM-DD') });
                  } else {
                    setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_dtVigFim: null, vaga_dtVigFim: null });
                  }
                }}
              />
              {dataFimVigenciaError && (
                <div style={{ color: '#dc3545', marginTop: 4 }}>
                  {dataFimVigenciaError}
                </div>
              )}
            </FormGroup>
          </Col>
          {!hideValorEstimado && !allowPedidoSemOrcItem && !showEquipeDetailFields && (
            <Col sm={4}>
              <FormGroup>
                <Label>
                  Valor total estimado
                </Label>
                <MaskedInput
                  unmask
                  mask="R$ num"
                  disabled={valorEstimadoDisabled || readOnly}
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2,
                      signed: false,
                      thousandsSeparator: '.',
                      padFractionalZeros: false,
                      normalizeZeros: false,
                      radix: ',',
                      min: 0,
                      max: 1000000000,
                    },
                  }}
                  lazy={false}
                  value={String((pedidoCompraData.pedidoCompra_vlrLimite || pedidoCompraData.vaga_salarioMaximo) ?? '')}
                  onAccept={value => {
                    if (!valorEstimadoDisabled && !readOnly) {
                      setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_vlrLimite: value, vaga_salarioMaximo: value });
                    }
                  }}
                />
              </FormGroup>
            </Col>
          )}
          {!readOnly && (
            <Col sm={12}>
              {(pedidoCompraData.pedidoCompra_dtVigIni && pedidoCompraData.pedidoCompra_dtVigFim) ? (
                vigenciaDatasInvalidas ? (
                  <div className="mb-2">
                    <span style={{ fontWeight: 'bold' }}>Datas de início e/ou fim erradas.</span>
                  </div>
                ) : (
                  <div className="mb-2 d-flex flex-wrap">
                    {resumoOrcamentoPorAno.map(({
                      year,
                      somaDotacoes,
                      valorDisponivel,
                      jaAlocados,
                    }) => (
                      <div key={year} className="d-flex flex-column mr-4 mb-2">
                        <strong className="mb-1">{year}</strong>
                        <span>
                          Valor disponível:{' '}
                          <span style={{ fontWeight: 'bold' }}>
                            {currencyFormatter.format(valorDisponivel)}
                          </span>
                        </span>
                        <span>
                          Soma de dotações para esse item:{' '}
                          <span style={{ fontWeight: 'bold' }}>
                            {currencyFormatter.format(somaDotacoes)}
                          </span>
                        </span>
                        <span>
                          Já alocados:{' '}
                          <span style={{ fontWeight: 'bold' }}>
                            {currencyFormatter.format(jaAlocados)}
                          </span>
                        </span>
                      </div>
                    ))}
                  </div>
                )
              ) : (
                <div className="mb-2">
                  <span style={{ fontWeight: 'bold' }}>
                    Selecione uma data de início e fim de prestação do serviço
                  </span>
                </div>
              )}
            </Col>
          )}
        </>
      )}

      {showFormFieldsAfterContratacao && !hideValorEstimado && allowPedidoSemOrcItem && !showEquipeDetailFields && (
        <Col sm={4}>
          <FormGroup>
            <Label>
              Valor total estimado
            </Label>
            <MaskedInput
              unmask
              mask="R$ num"
              disabled={valorEstimadoDisabled || readOnly}
              blocks={{
                num: {
                  mask: Number,
                  scale: 2,
                  signed: false,
                  thousandsSeparator: '.',
                  padFractionalZeros: false,
                  normalizeZeros: false,
                  radix: ',',
                  min: 0,
                  max: 1000000000,
                },
              }}
              lazy={false}
              value={String((pedidoCompraData.pedidoCompra_vlrLimite || pedidoCompraData.vaga_salarioMaximo) ?? '')}
              onAccept={value => {
                if (!valorEstimadoDisabled && !readOnly) {
                  setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_vlrLimite: value, vaga_salarioMaximo: value });
                }
              }}
            />
          </FormGroup>
        </Col>
      )}

      {showFormFieldsAfterContratacao && (
      <Col sm={12}>
        <FormGroup>
          <Label>
            Objeto resumido
          </Label>
          <Input
            type="textarea"
            placeholder="Escreva o objeto resumido da cotação"
            disabled={readOnly}
            value={(pedidoCompraData.pedidoCompra_desc || pedidoCompraData.vaga_descricao) ? pedidoCompraData.pedidoCompra_desc || pedidoCompraData.vaga_descricao : ''}
            onChange={(e) => { setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_desc: e.target.value, vaga_descricao: e.target.value }); }}
          />
        </FormGroup>
      </Col>
      )}

      {showEquipeDetailFields && (
        <>
          {/* <Col sm={6}>
            <FormGroup>
              <Label>Nome *</Label>
              <Input type="text" value={pedidoCompraData.vagaNome || ''} onChange={(e) => { setPedidoCompraData({ ...pedidoCompraData, vagaNome: e.target.value, vaga_nome: e.target.value }); }} />
            </FormGroup>
          </Col> */}
          <Col sm={6}>
            <FormGroup>
              <Label>Atuação</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={!readOnly}
                isSearchable={!readOnly}
                isDisabled={readOnly}
                options={projAtuacoes}
                value={projAtuacoes.find((projAtuacao) => (
                  Number(projAtuacao.value) === Number(pedidoCompraData.projAtuacao_id)
                  || Number(projAtuacao.value) === Number(pedidoCompraData.vagaCargo)
                  || projAtuacao.label === pedidoCompraData.vagaCargo
                  || projAtuacao.label === pedidoCompraData.vaga_cargo
                )) || null}
                onChange={(e) => {
                  if (readOnly) return;
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    projAtuacao_id: e?.value ?? null,
                    vagaCargo: e?.label ?? '',
                    vaga_cargo: e?.label ?? '',
                  });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Formação</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={!readOnly}
                isSearchable={!readOnly}
                isDisabled={readOnly}
                options={profissoes}
                value={profissoes.find((profissao) => (
                  Number(profissao.value) === Number(pedidoCompraData.vagaFormacao)
                  || profissao.label === pedidoCompraData.vagaFormacao
                  || profissao.label === pedidoCompraData.vaga_formacao
                )) || null}
                onChange={(e) => {
                  if (readOnly) return;
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    vagaFormacao: e?.label ?? '',
                    vaga_formacao: e?.label ?? '',
                  });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Estado de atuação (UF) *</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={!readOnly}
                isSearchable={!readOnly}
                isDisabled={readOnly}
                options={ufs}
                value={pedidoCompraData.vagaEstado
                  ? ufs.find((x) => Number(x.value) === Number(pedidoCompraData.vagaEstado))
                  : null}
                onChange={(e) => {
                  if (readOnly) return;
                  if (e) {
                    return setPedidoCompraData({ ...pedidoCompraData, vagaEstado: e.value, vaga_localidadeEstado: e.value });
                  }
                  return setPedidoCompraData({ ...pedidoCompraData, vagaEstado: null, vaga_localidadeEstado: null });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Cidade de atuação *</Label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                isClearable={!readOnly}
                isSearchable={!readOnly}
                isDisabled={readOnly || !pedidoCompraData.vagaEstado}
                options={filteredMunicipios}
                value={pedidoCompraData.vagaCidade
                  ? filteredMunicipios.find((x) => Number(x.value) === Number(pedidoCompraData.vagaCidade))
                  : null}
                onChange={(e) => {
                  if (readOnly) return;
                  if (e) {
                    return setPedidoCompraData({ ...pedidoCompraData, vagaCidade: e.value, vaga_localidadeCidade: e.value });
                  }
                  return setPedidoCompraData({ ...pedidoCompraData, vagaCidade: null, vaga_localidadeCidade: null });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Vínculo</Label>
              <Input
                type="select"
                disabled={readOnly}
                value={pedidoCompraData.vagaContrato || pedidoCompraData.vaga_tipoContrato || (readOnly ? '' : 'CLT')}
                onChange={(e) => {
                  if (readOnly) return;
                  setPedidoCompraData({ ...pedidoCompraData, vagaContrato: e.target.value, vaga_tipoContrato: e.target.value });
                }}
              >
                {readOnly && !(pedidoCompraData.vagaContrato || pedidoCompraData.vaga_tipoContrato) && (
                  <option value="">—</option>
                )}
                <option value="CLT">CLT</option>
                <option value="PJ">PJ</option>
                <option value="Estágio">Estágio</option>
                <option value="Contrato Temporário">Contrato Temporário</option>
                <option value="Associado">Associado</option>
                <option value="Cooperado">Cooperado</option>
                <option value="Menor aprendiz">Menor aprendiz</option>
                <option value="Autônomo">Autônomo</option>
              </Input>
            </FormGroup>
          </Col>
          {!hideValorEstimado && (
            <Col sm={6}>
              <FormGroup>
                <Label>
                  Valor total estimado
                </Label>
                <MaskedInput
                  unmask
                  mask="R$ num"
                  disabled={valorEstimadoDisabled || readOnly}
                  blocks={{
                    num: {
                      mask: Number,
                      scale: 2,
                      signed: false,
                      thousandsSeparator: '.',
                      padFractionalZeros: false,
                      normalizeZeros: false,
                      radix: ',',
                      min: 0,
                      max: 1000000000,
                    },
                  }}
                  lazy={false}
                  value={String((pedidoCompraData.pedidoCompra_vlrLimite || pedidoCompraData.vaga_salarioMaximo) ?? '')}
                  onAccept={value => {
                    if (!valorEstimadoDisabled && !readOnly) {
                      setPedidoCompraData({ ...pedidoCompraData, pedidoCompra_vlrLimite: value, vaga_salarioMaximo: value });
                    }
                  }}
                />
              </FormGroup>
            </Col>
          )}
          <Col sm={12}>
            <FormGroup>
              <Label>Escopo do serviço</Label>
              <Input
                type="textarea"
                rows="3"
                disabled={readOnly}
                value={pedidoCompraData.vagaEscopo || pedidoCompraData.vaga_escopo || ''}
                onChange={(e) => {
                  if (readOnly) return;
                  setPedidoCompraData({ ...pedidoCompraData, vagaEscopo: e.target.value, vaga_escopo: e.target.value });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Formato do trabalho</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecione"
                isClearable={!readOnly}
                isDisabled={readOnly}
                options={VAGA_CONDICOES_TRABALHO_OPTIONS}
                value={VAGA_CONDICOES_TRABALHO_OPTIONS.find(
                  (option) => option.value === (pedidoCompraData.vagaCondicoesTrabalho || pedidoCompraData.vaga_condicoesTrabalho),
                ) || null}
                onChange={(option) => {
                  if (readOnly) return;
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    vagaCondicoesTrabalho: option?.value ?? '',
                    vaga_condicoesTrabalho: option?.value ?? '',
                  });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Fornecedor dos EPIs</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecione"
                isClearable={!readOnly}
                isDisabled={readOnly}
                options={VAGA_FORNECEDOR_EPIS_OPTIONS}
                value={VAGA_FORNECEDOR_EPIS_OPTIONS.find(
                  (option) => option.value === (pedidoCompraData.vagaFornecedorEpis || pedidoCompraData.vaga_fornecedorEpis),
                ) || null}
                onChange={(option) => {
                  if (readOnly) return;
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    vagaFornecedorEpis: option?.value ?? '',
                    vaga_fornecedorEpis: option?.value ?? '',
                  });
                }}
              />
            </FormGroup>
          </Col>
          <Col sm={6}>
            <FormGroup>
              <Label>Benefícios</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecione"
                isMulti
                isClearable={!readOnly}
                isDisabled={readOnly}
                closeMenuOnSelect={false}
                options={CONTR_FORN_BENEFICIOS_OPTIONS}
                value={CONTR_FORN_BENEFICIOS_OPTIONS.filter((option) => (
                  parseContrFornBeneficios(pedidoCompraData.vaga_beneficios ?? pedidoCompraData.vagaBeneficios).includes(option.value)
                ))}
                onChange={(options) => {
                  if (readOnly) return;
                  const selectedBeneficios = (options || []).map((option) => option.value);
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    vaga_beneficios: selectedBeneficios,
                    vagaBeneficios: selectedBeneficios,
                  });
                }}
              />
            </FormGroup>
          </Col>
          {showEquipePedidoCompraFields && (
          <Col sm={6}>
            <FormGroup>
              <Label>Documentos Obrigatórios</Label>
              <Select
                classNamePrefix="select2-selection"
                placeholder="Selecione"
                isMulti
                isClearable={!readOnly}
                isDisabled={readOnly}
                closeMenuOnSelect={false}
                options={documentosObrigatorios}
                value={documentosObrigatorios.filter((option) => (
                  parseMultiSelectIds(
                    pedidoCompraData.vaga_documentosObrigatorios ?? pedidoCompraData.vagaDocumentosObrigatorios,
                  ).includes(Number(option.value))
                ))}
                onChange={(options) => {
                  if (readOnly) return;
                  const selectedDocumentos = (options || []).map((option) => Number(option.value));
                  setPedidoCompraData({
                    ...pedidoCompraData,
                    vaga_documentosObrigatorios: selectedDocumentos,
                    vagaDocumentosObrigatorios: selectedDocumentos,
                  });
                }}
              />
            </FormGroup>
          </Col>
          )}
          <Col sm={12}>
            <FormGroup>
              <Label>Requisitos</Label>
              <Input
                type="textarea"
                disabled={readOnly}
                value={pedidoCompraData.vagaRequisitos || pedidoCompraData.vaga_requisitos || ''}
                onChange={(e) => {
                  if (readOnly) return;
                  setPedidoCompraData({ ...pedidoCompraData, vagaRequisitos: e.target.value, vaga_requisitos: e.target.value });
                }}
              />
            </FormGroup>
          </Col>
        </>
      )}

      {showFormFieldsAfterContratacao && !hideAnexos && (
        <Col sm={12}>
          <FormGroup>
            <Label>
              Anexos complementares
            </Label>
            <AddFiles
              multiple={true}
              readOnly={readOnly}
              files={filesPedidoCompra}
              onFilesChange={readOnly ? () => {} : setFilesPedidoCompra}
            />
          </FormGroup>
        </Col>
      )}
    </Row>
  );
}

function ModalPedidoCompra({
  isOpen,
  onClose = () => {},
  initialPedidoCompraData = EMPTY_OBJECT,
  initialFilesPedidoCompra = EMPTY_ARRAY,
  editPedidoCompraRow = null,
  editCompraCotacaoRow = null,
  selCentroDeCusto = [],
  selOrcItems = [],
  selPropItems = [],
  filteredValoresLimites = [],
  onSuccess = () => {},
  onSkipCotacao = () => {},
  showSkipCotacao = true,
  title = 'Abrir cotação',
  submitLabel = 'Adicionar cotação',
  hideCentroDeCusto = false,
  hideOrcItem = false,
  hidePropItem = false,
  hideQuantidadeOportunidades = false,
  valorEstimadoDisabled = false,
  hideValorEstimado = false,
  hideDtLimite = false,
  hideAnexos = false,
  showEquipePedidoCompraFields = false,
  allowPedidoSemOrcItem = false,
  readOnly = false,
  readOnlyOrcItem = false,
  contratoDtAssin = null,
  contratoPrazoVigencia = null,
  contratoPrazoVigenciaAditivo = null,
  user = null,
  onEquipeSuccess = () => {},
  createLinkedTasks = null,
  initialVagaTipo = '',
  resubmitLabel = 'Reenviar para aprovacao',
  modoCotacao = false,
  cotacaoParaPedidoExistente = false,
  compraCotacaoParaPedidoCompra = null,
  pedidoCompraPedidoCotacao = null,
  filterOrcItemCategGrId = null,
}) {
  const [vagaTipo, setVagaTipo] = React.useState('');
  const [isOpeningInhireVaga, setIsOpeningInhireVaga] = React.useState(false);
  const controller = usePedidoCompraModalController({
    isOpen,
    initialPedidoCompraData,
    initialFilesPedidoCompra,
    editPedidoCompraRow,
    editCompraCotacaoRow,
    readOnly,
    hideCentroDeCusto,
    showEquipePedidoCompraFields,
    allowPedidoSemOrcItem,
    modoCotacao,
    cotacaoParaPedidoExistente,
    compraCotacaoParaPedidoCompra,
    selOrcItems,
    user,
    onClose,
    onSuccess,
    pedidoCompraPedidoCotacao,
    filterOrcItemCategGrId,
  });

  const {
    pedidoCompraData,
    setPedidoCompraData,
    filesPedidoCompra,
    setFilesPedidoCompra,
    listaDotacoes,
    setListaDotacoes,
    valoresLimites,
    getOrcDots,
    submitPedidoCompra,
    isSubmitting,
    resolvedSelOrcItems,
    close,
  } = controller;

  const isResubmitMode = Boolean(
    pedidoCompraData?.pedidoCompra_id
    && Number(pedidoCompraData?.pedidoCompraStatus_id) === 6,
  );

  const modalTitle = isResubmitMode
    ? `Editar ${modoCotacao ? 'cotação' : (showEquipePedidoCompraFields ? 'vaga' : 'cotação')}`
    : title;

  const selectedOrcItem = React.useMemo(
    () => resolvedSelOrcItems.find((item) => Number(item.value) === Number(pedidoCompraData.orcItem_id)) || null,
    [resolvedSelOrcItems, pedidoCompraData.orcItem_id],
  );

  const enableEquipeFlow = !readOnly && !modoCotacao && (
    showEquipePedidoCompraFields
    || Number(selectedOrcItem?.categGr_id) === EQUIPE_CATEG_GR_ID
  );

  const showEquipeContratacaoUi = !modoCotacao && (
    enableEquipeFlow
    || (
      readOnly
      && (
        showEquipePedidoCompraFields
        || Number(pedidoCompraData?.categGr_id) === EQUIPE_CATEG_GR_ID
        || Number(pedidoCompraData?.vaga_id) > 0
        || Number(selectedOrcItem?.categGr_id) === EQUIPE_CATEG_GR_ID
      )
    )
  );

  const handleSuccess = React.useCallback(async (payload) => {
    await onEquipeSuccess(payload);
    await onSuccess(payload);
  }, [onEquipeSuccess, onSuccess]);

  const equipeActions = usePedidoCompraEquipeActions({
    pedidoCompraData,
    setPedidoCompraData,
    filesPedidoCompra,
    user,
    showEquipePedidoCompraFields: showEquipePedidoCompraFields || enableEquipeFlow,
    vagaTipo,
    onSuccess: handleSuccess,
    onClose: close,
    createLinkedTasks,
  });

  const handleVagaTipoChange = React.useCallback((nextVagaTipo) => {
    setVagaTipo(nextVagaTipo);
    if (nextVagaTipo !== 'interno') {
      setPedidoCompraData((prev) => ({
        ...prev,
        orcItem_original: null,
      }));
    }
  }, [setPedidoCompraData]);

  React.useEffect(() => {
    if (!isOpen) {
      setVagaTipo('');
      return;
    }

    if (initialVagaTipo && initialVagaTipo !== 'alocar') {
      setVagaTipo(initialVagaTipo);
    } else if (pedidoCompraData.orcItem_original) {
      setVagaTipo('interno');
    } else if (Number(pedidoCompraData.pedidoCompraStatus_id) === 6) {
      setVagaTipo('externo');
    } else if (
      readOnly
      && (
        Number(pedidoCompraData.vaga_id) > 0
        || showEquipePedidoCompraFields
      )
    ) {
      setVagaTipo('externo');
    }
  }, [
    isOpen,
    initialVagaTipo,
    pedidoCompraData.orcItem_original,
    pedidoCompraData.pedidoCompraStatus_id,
    pedidoCompraData.vaga_id,
    readOnly,
    showEquipePedidoCompraFields,
  ]);

  React.useEffect(() => {
    if (!isOpen || !enableEquipeFlow || !pedidoCompraData.orcItem_id) return;

    let cancelled = false;
    const orcItemId = Number(pedidoCompraData.orcItem_id);

    const syncContratoFornFromOrcItem = async () => {
      const selectedItem = resolvedSelOrcItems.find(
        (item) => Number(item.value) === orcItemId,
      );
      let contratoFornId = Number(selectedItem?.contratoForn_id) || 0;

      if (!contratoFornId) {
        contratoFornId = await fetchOrcItemContratoFornId(orcItemId);
      }

      if (cancelled) return;

      if (contratoFornId) {
        setPedidoCompraData((prev) => {
          if (Number(prev.orcItem_id) !== orcItemId) return prev;
          if (Number(prev.contratoForn_id) === contratoFornId && prev.contratoForn_idLocked) {
            return prev;
          }
          return {
            ...prev,
            contratoForn_id: contratoFornId,
            contratoForn_idLocked: true,
          };
        });
      }
    };

    syncContratoFornFromOrcItem();

    return () => {
      cancelled = true;
    };
  }, [isOpen, enableEquipeFlow, pedidoCompraData.orcItem_id, resolvedSelOrcItems, setPedidoCompraData]);

  React.useEffect(() => {
    if (!isOpen || vagaTipo !== 'interno') return;
    if (!enableEquipeFlow && !showEquipeContratacaoUi) return;
    equipeActions.loadOrcItemsOriginais(
      selectedOrcItem?.nivel2_id || pedidoCompraData.centroDeCustoRubr_id || null,
    );
  }, [
    isOpen,
    enableEquipeFlow,
    showEquipeContratacaoUi,
    vagaTipo,
    selectedOrcItem?.nivel2_id,
    pedidoCompraData.centroDeCustoRubr_id,
  ]);

  const handleClose = () => {
    setVagaTipo('');
    close();
  };

  const vagaInhireId = String(pedidoCompraData?.vaga_inhireId || '').trim();
  const showInhireFooter = Boolean(
    readOnly
    && !modoCotacao
    && (
      showEquipePedidoCompraFields
      || Number(pedidoCompraData?.vaga_id) > 0
      || Number(pedidoCompraData?.categGr_id) === EQUIPE_CATEG_GR_ID
    )
    && Number(pedidoCompraData?.vaga_id || pedidoCompraData?.pedidoCompra_id) > 0,
  );
  const inhireJobUrl = vagaInhireId
    ? `https://ecossis.inhire.app/jobs/${encodeURIComponent(vagaInhireId)}`
    : null;

  const handleAbrirVagaInhire = React.useCallback(async () => {
    const pedidoCompraId = Number(pedidoCompraData?.pedidoCompra_id) || 0;
    if (!pedidoCompraId) {
      notifyError('Não foi possível identificar a cotação da vaga.');
      return;
    }

    try {
      setIsOpeningInhireVaga(true);
      const result = await abrirVagaInhireParaPedidoCompra(pedidoCompraId);
      if (result?.ok && result.inhireJobId) {
        setPedidoCompraData((prev) => ({
          ...prev,
          vaga_inhireId: result.inhireJobId,
        }));
        await onSuccess?.({
          pedidoCompra_id: pedidoCompraId,
          vaga_id: result.vagaId || pedidoCompraData?.vaga_id,
          vaga_inhireId: result.inhireJobId,
        });
      }
    } finally {
      setIsOpeningInhireVaga(false);
    }
  }, [
    onSuccess,
    pedidoCompraData?.pedidoCompra_id,
    pedidoCompraData?.vaga_id,
    setPedidoCompraData,
  ]);

  return (
    <>
    <Modal
      isOpen={isOpen}
      toggle={handleClose}
      size={modoCotacao ? 'lg' : 'xl'}
    >
      <ModalHeader toggle={handleClose}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          {modalTitle}
        </Typography>
      </ModalHeader>
      <ModalBody>
        <PedidoCompraForm
          pedidoCompraData={pedidoCompraData}
          setPedidoCompraData={setPedidoCompraData}
          selCentroDeCusto={selCentroDeCusto}
          selOrcItems={resolvedSelOrcItems}
          selPropItems={selPropItems}
          listaDotacoes={listaDotacoes}
          setListaDotacoes={setListaDotacoes}
          filteredValoresLimites={filteredValoresLimites}
          valoresLimites={valoresLimites}
          filesPedidoCompra={filesPedidoCompra}
          setFilesPedidoCompra={setFilesPedidoCompra}
          getOrcDots={getOrcDots}
          hideCentroDeCusto={hideCentroDeCusto}
          hideOrcItem={hideOrcItem}
          hidePropItem={hidePropItem}
          hideQuantidadeOportunidades={hideQuantidadeOportunidades}
          valorEstimadoDisabled={valorEstimadoDisabled}
          hideValorEstimado={hideValorEstimado}
          hideDtLimite={hideDtLimite}
          hideAnexos={hideAnexos}
          showEquipePedidoCompraFields={showEquipePedidoCompraFields}
          allowPedidoSemOrcItem={allowPedidoSemOrcItem}
          readOnly={readOnly}
          readOnlyOrcItem={readOnlyOrcItem}
          contratoDtAssin={contratoDtAssin}
          contratoPrazoVigencia={contratoPrazoVigencia}
          contratoPrazoVigenciaAditivo={contratoPrazoVigenciaAditivo}
          vagaTipo={vagaTipo}
          onVagaTipoChange={handleVagaTipoChange}
          selOrcItemsOriginais={equipeActions.selOrcItemsOriginais}
          isLoadingOrcItemsOriginais={equipeActions.isLoadingOrcItemsOriginais}
          showContratacaoRadios={showEquipeContratacaoUi}
          isResubmitMode={isResubmitMode}
          modoCotacao={modoCotacao}
        />
      </ModalBody>
      <ModalFooter className={showInhireFooter ? 'd-flex justify-content-between align-items-center flex-wrap' : undefined}>
        {showInhireFooter && (
          <div className="d-flex align-items-center mr-auto mb-2 mb-sm-0">
            <span className="mr-2 font-weight-bold">Vaga no inhire</span>
            {vagaInhireId && inhireJobUrl ? (
              <a
                href={inhireJobUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                {inhireJobUrl}
              </a>
            ) : (
              <Button
                color="primary"
                onClick={handleAbrirVagaInhire}
                disabled={isOpeningInhireVaga}
              >
                {isOpeningInhireVaga ? 'Abrindo...' : 'Abrir vaga no inhire'}
              </Button>
            )}
          </div>
        )}
        <div className="d-flex align-items-center flex-wrap">
          <Button
            onClick={handleClose}
            disabled={equipeActions.isSavingContratoInterno || equipeActions.isSavingPedidoCompraEquipe || equipeActions.isCreatingInhireVaga || isOpeningInhireVaga}
          >
            Fechar
          </Button>
          {!readOnly && enableEquipeFlow ? (
            <>
              {(vagaTipo === 'interno' || vagaTipo === 'externo') && (
                <Button
                  className="ml-2"
                  onClick={equipeActions.abrirVagaPedidoCompra}
                  color="primary"
                  disabled={equipeActions.isSavingPedidoCompraEquipe}
                >
                  {equipeActions.isSavingPedidoCompraEquipe
                    ? 'Salvando...'
                    : (isResubmitMode ? resubmitLabel : 'Abrir vaga')}
                </Button>
              )}
            </>
          ) : !readOnly && (
            <>
              <Button className="ml-2" onClick={submitPedidoCompra} color="primary" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : (isResubmitMode ? resubmitLabel : submitLabel)}
              </Button>
              {showSkipCotacao && (
                <Button className="ml-2" onClick={onSkipCotacao} color="primary">Pular cotação</Button>
              )}
            </>
          )}
        </div>
      </ModalFooter>
    </Modal>
    </>
  );
}

export default ModalPedidoCompra;
